/** 板块 key → 名称（all=全部聚合视图；announcement=公告：仅管理端可发帖） */
export const BOARD_LABEL: Record<string, string> = {
  all: '全部',
  chat: '闲聊',
  divination: '占卜',
  qa: '问答',
  announcement: '公告',
};

export function boardLabel(key: string): string {
  return BOARD_LABEL[key] ?? key;
}
